import { render } from "./AGCARE.vue?vue&type=template&id=24515db2&scoped=true"
import script from "./AGCARE.vue?vue&type=script&lang=js"
export * from "./AGCARE.vue?vue&type=script&lang=js"

import "./AGCARE.vue?vue&type=style&index=0&id=24515db2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24515db2"]])

export default __exports__